module.exports = __webpack_public_path__ + "img/sidebar_laliga_202627.e6ecc5c9.png";